import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomFacebook({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.852 18H8.179c-.447 0-.81-.348-.81-.776v-5.78H5.81c-.446 0-.809-.348-.809-.776V8.192c0-.428.363-.776.81-.776h1.56v-1.24c0-1.23.402-2.276 1.164-3.025C9.299 2.398 10.369 2 11.627 2l2.038.003c.446 0 .809.35.809.776v2.3c0 .428-.363.776-.81.776h-1.372c-.419 0-.525.08-.548.105-.038.041-.082.157-.082.476v.98h1.9c.142 0 .28.034.4.097a.774.774 0 01.416.68v2.476c0 .427-.364.775-.81.775h-1.906v5.78c0 .428-.364.776-.81.776zm-2.504-.938h2.335v-6.037a.53.53 0 01.54-.519H13.4V8.354h-2.176a.53.53 0 01-.54-.518v-1.4c0-.366.039-.783.327-1.096.349-.38.898-.423 1.282-.423h1.203V2.94l-1.869-.003c-2.022 0-3.278 1.24-3.278 3.238v1.66a.53.53 0 01-.54.518h-1.83v2.152h1.83a.53.53 0 01.54.519v6.037z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomFacebook;
